import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { NavigationEnd, Params, Router } from '@angular/router';
import { ProvidersService } from '../../../providers.service';
import {Location} from '@angular/common'; 
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-salesreps-create-pricelist',
  templateUrl: './salesreps-create-pricelist.component.html',
  styleUrls: ['./salesreps-create-pricelist.component.scss']
})
export class SalesrepsCreatePricelistComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  createPricelistForm: FormGroup;
  Pricelists: Array<any>;
  previousUrl: string;


  constructor(private _location: Location, private fb: FormBuilder, private router: Router, public dialog: MatDialog, private providersService: ProvidersService, private toastr:ToastrService) {
    super();

    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
       
        this.previousUrl = event.url;
      });
    let httpParams: Params = { input: 'null' }
    //let pricelisttype : 'ho'
    this.providersService.getsalesrepsPricelists().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
       
        this.Pricelists = resData;
      }
    })
  }

  private initForm() {
    this.createPricelistForm = this.fb.group({
      PricelistName: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      copyFrom: ['', [Validators.required]]
    })
  }

  get f() {
    return this.createPricelistForm.controls;
  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  ngOnInit(): void {
    super.ngOnInit()
    this.createPricelistForm = this.fb.group({
      PricelistName: '',
      copyFrom: ''

    })
  }
  onCancel() { this.router.navigate(['features/providers/salesreps/pricelist']);}
  onSubmit() {
   
    if (this.createPricelistForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.createPricelistForm)
        }else{
          this.router.navigate(['features/providers/salesreps/pricelist']);
        }
      });

    }
    //
  }
  setSubmitParameters(createPricelistForm: FormGroup) {

    let httpParams: Params = {
      SourcePricelistname: createPricelistForm.get('copyFrom').value,
      DestinationPricelistname: createPricelistForm.get('PricelistName').value
    }
    //

    this.providersService.getcreatePricelist(httpParams).subscribe(res => {
      if (res && res) { //alert("h3"); 
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.router.navigate(['features/providers/salesreps/pricelist'])
          this.toastr.success('PriceList added successfully', 'Success', {
            timeOut: 3000,
          });        
      }else{
          //
          
        Swal.fire(
          {
            title: res.responseStatus,
            text: res.userMessage,
            icon: 'error',
            timer: 2000
          }
        )
       
        this.router.navigate(['features/providers/salesreps/pricelist'])
        //this._location.back();
        }
      }
    });
  }

  
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
